import { Horizontal, Texto } from '@gravitate-js/excalibrr'

type StorageDetailVolumeProps = {
  current_volume?: number | string
  projected_volume?: number | string
  storage_max?: number | string
}

export function StorageDetailVolume({ current_volume, projected_volume, storage_max }: StorageDetailVolumeProps) {
  return (
    <Horizontal justifyContent='space-between'>
      <Texto className='text-ellipsis' category='label'>
        {current_volume}/{storage_max}
      </Texto>
      {projected_volume && (
        <Texto category='label' weight='bold' className='text-ellipsis'>
          {projected_volume}
        </Texto>
      )}
    </Horizontal>
  )
}
